import React from 'react';
import './SearchSection.css';

import SearchBox from './SearchBox';
import HintSection from './HintSection';

function SearchSection() {
  return (
    <div className="search-section">
        <div className="search-section-content">
            <h1 className="search-section-title">Where Your Authentic China Journey Begins...</h1>
            <SearchBox />
            <HintSection />
        </div>
    </div>
  );
}

export default SearchSection;

